"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectField = void 0;
const react_1 = __importDefault(require("react"));
const SELECT_PLACEHOLDERS = {
    gender: 'Choose…',
    genderId: 'Choose…',
    courseId: 'Choose your course…',
    programId: 'Choose your programme…',
    schoolId: 'Select a centre…',
    academicYearId: 'Select year…',
    enquiryMode: 'How will you study?…',
    enquiryType: 'Select enquiry type…',
    studyingInstitute: 'Select institute…',
    leadToInstitute: 'How did you hear about us?…',
    nationality: 'Select nationality…',
    countryOfDomicile: 'Select country…',
    casteId: 'Choose category…',
    domicile: 'Select state…',
    country: 'Select country…',
    state: 'Select state…',
    district: 'Select district…',
};
function placeholderFor(field) {
    return SELECT_PLACEHOLDERS[field.key] || `Select ${field.label.toLowerCase()}…`;
}
const SelectField = ({ field, value, onChange, error, disabled, lookups }) => {
    let options = [];
    if (field.options) {
        options = field.options;
    }
    else if (field.lookup && lookups?.[field.lookup]) {
        options = lookups[field.lookup];
    }
    return (react_1.default.createElement("div", { className: "field-group" },
        react_1.default.createElement("label", { className: "field-label", htmlFor: field.key },
            field.label,
            field.required && react_1.default.createElement("span", { className: "required" }, "*")),
        react_1.default.createElement("select", { id: field.key, className: `field-input${error ? ' error' : ''}`, name: field.key, value: value != null ? String(value) : '', onChange: (e) => onChange(field.key, e.target.value || null), disabled: disabled },
            react_1.default.createElement("option", { value: "" }, placeholderFor(field)),
            options.map((opt) => (react_1.default.createElement("option", { key: opt.value, value: String(opt.value) }, opt.label)))),
        field.tooltip && react_1.default.createElement("div", { className: "field-hint" }, field.tooltip),
        error && react_1.default.createElement("div", { className: "field-error" }, error)));
};
exports.SelectField = SelectField;
